
var fileServerUrl = null
var fileServerAppName = null
var fileServerGetFileUrl = null

export function getFileServerUrl () {
  if (fileServerUrl == null) {
    fileServerUrl = process.env.VUE_APP_FILE_SERVER_URL || ''
    if (fileServerUrl.endsWith('/')) {
      fileServerUrl = fileServerUrl.substring(0, fileServerUrl.length - 1)
    }
  }
  return fileServerUrl
}

export function getFileServerAppName () {
  if (fileServerAppName == null) {
    fileServerAppName = process.env.VUE_APP_FILE_SERVER_APPNAME || ''
  }
  return fileServerAppName
}

export function getGetFileUrl () {
  if (fileServerGetFileUrl == null) {
    fileServerGetFileUrl = getFileServerUrl() + '/GetFile/' + getFileServerAppName()
  }
  return fileServerGetFileUrl
}
